exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ba-common-autoCompleteInput{position:relative;display:inline-block}.ba-common-autoCompleteInput.is-fullWidth{display:block}.ba-common-autoCompleteInput.is-fullWidth .ba-common-searchInput{width:100%}", ""]);

// exports
exports.locals = {
	"autoCompleteInputClassName": "\"ba-common-autoCompleteInput\""
};